module.exports = __webpack_public_path__ + "static/img/banner.ca16742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealer/banner.png
// module id = w/o1
// module chunks = 1